export default __webpack_public_path__ + "static/og-image-abfed750a48de1f9b781573123df1596.jpg";